import React from 'react';
import PropTypes from 'prop-types';

import ContactCircleShare from './ContactCircleShare';
import withModal from '../modal/withModal';

const propTypes = {
  actionProps: PropTypes.shape({
    circle: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const ContactCircleShareModal = ({ actionProps, ...props }) => {
  const { circle } = actionProps ?? {};
  return <ContactCircleShare circleId={circle?.id} {...props} />;
};

ContactCircleShareModal.propTypes = propTypes;

export const CONTACT_CIRCLE_SHARE_MODAL = 'modal/CONTACT_CIRCLE_SHARE';

export default withModal(ContactCircleShareModal, {
  name: CONTACT_CIRCLE_SHARE_MODAL,
  dismissible: false,
  hideHeader: true,
  overlayClassName: 'contact-circle-share-modal',
  size: 'sm',
  type: 'full',
});
